<template>
  <div class="hold-transition sidebar-mini layout-footer-fixed">
    <div class="wrapper">
      <Navbar />
      <Sidebar />
      <Content />
      <Footer />
      <!-- <ControlSidebar />
      <InitialMessage />  -->
    </div>
    <!-- ./wrapper -->
  </div>
</template>

<script>
import "./assets/js/admilte";
import Navbar from "./layout/Navbar";
import Sidebar from "./layout/Sidebar";
import Footer from "./layout/Footer";
//import ControlSidebar from "./layout/ControlSidebar";
import Content from "./layout/Content";
//import InitialMessage from "./layout/InitialMessage";

import { mapActions } from "vuex";

export default {
  components: {
    Navbar,
    Sidebar,
    Footer,
    //ControlSidebar,
    Content,
    //InitialMessage,
  },
  methods: {
    ...mapActions(["getResoluciones"]),
  },
  mounted() {
    // Carga data inicial
    const loader = this.$loading.show();
    this.getResoluciones().finally(() => loader.hide());
  },
};
</script>

<style>
@import "./assets/css/adminlte.css";
@import "./assets/css/fontawesome-free/css/all.css";
@import "./assets/css/custom.css";
</style>
